import { render, staticRenderFns } from "./chooseThirdUserDialog.vue?vue&type=template&id=1f8b95a5&scoped=true&"
import script from "./chooseThirdUserDialog.vue?vue&type=script&lang=js&"
export * from "./chooseThirdUserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8b95a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f8b95a5')) {
      api.createRecord('1f8b95a5', component.options)
    } else {
      api.reload('1f8b95a5', component.options)
    }
    module.hot.accept("./chooseThirdUserDialog.vue?vue&type=template&id=1f8b95a5&scoped=true&", function () {
      api.rerender('1f8b95a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/user/chooseThirdUserDialog.vue"
export default component.exports